module.exports = __webpack_public_path__ + "static/media/spritual4.ee55d187.webp";